import { IApi } from '@/setup/api-client'
import { useApiMutation } from '@/utils/api/api-mutation'
import { useApiToolbox } from '@/utils/api/use-api-toolbox'
import type { IUpdateMemberRoleBody } from 'api/dist/routes/organization/[organization_id]/members/[user_id]/role.js'
import { GetMembersQuery } from '@/api/organization/members/get-members-query'
import { GetMembersPolicyQuery } from '@/api/organization/members/get-members-policy-query'

interface IUpdateMemberRoleArgs {
    organizationId: string
    userId: string
    body: IUpdateMemberRoleBody
}

export class UpdateMemberRoleMutation {
    static async call(api: IApi, args: IUpdateMemberRoleArgs) {
        return api
            .patch(`/organization/${args.organizationId}/members/${args.userId}/role`, args.body)
            .then((res) => res.data)
    }
}

export function useUpdateMemberRoleMutation() {
    const { api, apiParams, qc } = useApiToolbox()

    return useApiMutation<unknown, { userId: string; role: 'org:admin' | 'org:member' }>({
        mutationFn: ({ userId, role }) =>
            UpdateMemberRoleMutation.call(api, {
                organizationId: apiParams.organizationId,
                userId,
                body: { role },
            }),
        onSuccess: () => {
            qc.invalidateQueries({
                queryKey: GetMembersQuery.getKey({ organizationId: apiParams.organizationId }),
            })
            qc.invalidateQueries({
                queryKey: GetMembersPolicyQuery.getKey({ organizationId: apiParams.organizationId }),
            })
        },
    })
}
